//Include Both Helper File with needed methods
import {
  postDecodeEncryptLogin,
  postFakeLogin,
  postJwtLogin,
} from "../../../helpers/ServiceHelpers/backend_helper";

import { loginSuccess, apiError, reset_login_flag } from "./reducer";
import { getLanguageCodeForAuthPages } from "helpers/Others/language_helper";

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    let response: any;

    if (process.env.REACT_APP_DEFAULTAUTH === "classic") {
      if (!user.email && user.encryptedText) {
        const { ownCreateContractPrm, ...cleanedUser } = user;
        response = await postDecodeEncryptLogin({
          encryptedText: cleanedUser.encryptedText,
        });
      } else {
        response = await postFakeLogin({
          email: user.email,
          password: user.password,
        });
      }
    }

    if (response?.status && response?.status !== 200) {
      if (response?.data?.isRedirectSCA) {
        window.location.href =
          process.env.REACT_APP_INVEST_SCA_PARTNERSHIP_REDIRECT_URL!;
      } else {
        const errorMessage =
          response.message ||
          response.data.message ||
          "An error occurred during login";
        dispatch(apiError(errorMessage));
      }
      return;
    }

    if (response) {
      sessionStorage.setItem("authUser", JSON.stringify(response));
      await dispatch(loginSuccess(response));

      if (process.env.REACT_APP_DEFAULTAUTH === "classic") {
        const path =
          user.ownCreateContractPrm === "1" ? "/create-contract" : "/dashboard";
        history(path);
        window.location.reload();
      } else {
        history("/dashboard");
      }
    } else {
      dispatch(apiError("Login failed"));
    }
  } catch (error: any) {
    const backendMessage =
      error.response?.data?.message ||
      error.customMessage ||
      error.message ||
      "Login failed";

    dispatch(apiError(backendMessage));
  }
};

export const logoutUser = () => async (dispatch: any) => {
  try {
    const currentLanguage: any = sessionStorage.getItem("I18N_LANGUAGE");
    const isRedirectedToLoginLng = getLanguageCodeForAuthPages(currentLanguage);

    sessionStorage.removeItem("I18N_LANGUAGE");
    sessionStorage.removeItem("authUser");
    localStorage.removeItem("authData");

    return isRedirectedToLoginLng;
  } catch (error: any) {
    dispatch(apiError(error));
    return "en";
  }
};

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error: any) {
    dispatch(apiError(error));
  }
};
